import React, { useState } from 'react';
import DefaultHeader from '../Wizard/DefaultHeader';
import DefaultFooter from '../Wizard/DefaultFooter';
import { Container, Paper, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Wizard from '../Wizard';
import StepConfigNotification from './StepConfigNotification';
import StepUploadFileData from './StepUploadFIleData';
import StepUploadAttachments from './StepUploadAttachments';
import StepPrevisualization from './StepPrevisualization';
import LoadingCard from '../UI/LoadingCard';
import { Storage } from 'aws-amplify';
import * as XLSX from 'xlsx';
import API_REST from '../../api-rest-uruk';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%'
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    [theme.breakpoints.down(600 + theme.spacing(6))]: {
      maxWidth: '100%'
    }
  }
}));

const configWidzard = {
  title: 'StepperWizard:title',
  steps: [
    { key: 'firstStep', label: 'StepperWizard:config' },
    { key: 'secondStep', label: 'StepperWizard:addCSV' },
    { key: 'thirdStep', label: 'StepperWizard:addAttachment' },
    { key: 'finalStep', label: 'StepperWizard:preview' }
  ]
};

const formState = {
  step1: {}
};

const uploadXLSXAndAttach = async (file, path) => (
  Storage.put(path, file, {
    contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
);

function WizardBulkNotifications () {
  const [ state, setState ] = useState(formState);
  const [ showBtnNext, setShowBtnNext ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [error, setError] = useState();
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const handleNext = async (submit) => {
    try {
      if (submit) {
        setLoading(true);
        const id = crypto.randomUUID();
        const subgroup = 'prueba';
        let xlsxPath = `bulk_notification/${subgroup}/${id}/template.xlsx`;
        let attachmentFiles = [];
        if (state.step2 && state.step2.workbook) {
          var data = XLSX.write(state.step2.workbook, { type: 'buffer' });
          await uploadXLSXAndAttach(data, xlsxPath);
        }

        if (state.step3 && state.step3.attachmentFiles) {
          let allS3ToUpload = [];
          for (let index = 0; index < state.step3.attachmentFiles.length; index++) {
            const attachment = state.step3.attachmentFiles.item(index);
            const path = `bulk_notification/${subgroup}/${id}/${attachment.name}`;
            attachmentFiles.push(path);
            allS3ToUpload.push(uploadXLSXAndAttach(attachment, path));
          }
          await Promise.all(allS3ToUpload);
        }

        const { auditLevel, openAction, type, template: { subject, content } } = state.step1;

        const attachmentFilesParse = attachmentFiles.map(attachment => `public/${attachment}`);

        API_REST.createBulkNotification({
          auditLevel,
          openAction,
          type,
          rawSubject: subject,
          rawMessage: content,
          xlsxPath: `public/${xlsxPath}`,
          attachmentFiles: attachmentFilesParse
        }).then(async () => {
          setLoading(false);
          history.push('/notification');
        }).catch((err) => {
          setError(t(`wizardBulkNotification:errors:${err.response.data.code || 'generic'}`));
          setLoading(false);
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Container>
      <LoadingCard open={loading} loading message={t('wizardBulkNotification:creatingNotifications')} />
      <Paper elevation={3} variant='outlined' className={classes.paper}>
        {error && (
          <Alert severity='error' onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        <div className={classes.container}>
          <Wizard
            header={<DefaultHeader config={configWidzard} />}
            footer={<DefaultFooter handleNext={handleNext} disabled={showBtnNext} />}>
            <StepConfigNotification data={state} onChange={setState} setIsValid={setShowBtnNext} />
            <StepUploadFileData data={state} onChange={setState} setIsValid={setShowBtnNext} />
            <StepUploadAttachments data={state} onChange={setState} setIsValid={setShowBtnNext} />
            <StepPrevisualization data={state} onChange={setState} setIsValid={setShowBtnNext} />
          </Wizard>
        </div>
      </Paper>
    </Container>
  );
}

export default WizardBulkNotifications;
